"use strict";

exports.__esModule = true;
var _ReportScreen = require("./ReportScreen");
Object.keys(_ReportScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportScreen[key]) return;
  exports[key] = _ReportScreen[key];
});